import { render, staticRenderFns } from "./background_setting.vue?vue&type=template&id=6f67a4eb&"
import script from "./background_setting.vue?vue&type=script&lang=js&"
export * from "./background_setting.vue?vue&type=script&lang=js&"
import style0 from "./background_setting.vue?vue&type=style&index=0&id=6f67a4eb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports